import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';
import select2 from 'select2';

select2($);

export default class extends Controller {
  static targets = ["country", "rate", "ht", "ttc", "tva", "coefHt", "coefTtc"];
  static values = {
    defaultCountry: String,
    allCountry: Boolean
  };

  connect() {
    this.loadVatRates();
  }

  disconnect() {
    if ($(this.countryTarget).data('select2')) {
      $(this.countryTarget).select2('destroy');
    }
  }

  initSelect2() {
    // Détruire select2 s'il existe déjà
    if ($(this.countryTarget).data('select2')) {
      $(this.countryTarget).select2('destroy');
    }

    // Initialiser Select2 avec template pour les drapeaux
    $(this.countryTarget).select2({
      templateResult: this.formatCountryOption.bind(this),
      templateSelection: this.formatCountryOption.bind(this),
      minimumResultsForSearch: Infinity,
      width: '100%',
      dropdownParent: $(this.countryTarget).parent()
    });

    // Écouter les changements (utiliser select2:select au lieu de change)
    $(this.countryTarget).off('select2:select').on('select2:select', () => {
      this.updateRates();
    });
  }

  formatCountryOption(country) {
    if (!country.id) return country.text;

    const flagUrl = this.getFlagUrl(country.id);
    return $(`
      <span class="select2-country">
        <img class="select2-country__flag" src="${flagUrl}" alt="${country.id}" />
        <span class="select2-country__name">${country.id}</span>
      </span>
    `);
  }

  async loadVatRates() {
    try {
      const response = await fetch('/wp-json/mezcalito/v1/vat-rates');
      this.vatData = await response.json();

      this.populateCountries(this.vatData);
      this.countryTarget.value = this.defaultCountryValue;
      await this.updateRates();
    } catch (error) {
      // Error silencieuse en production
    }
  }

  populateCountries(vatData) {
    const countries = this.allCountryValue
      ? [...new Set(vatData.map(r => r.country))]
      : [this.defaultCountryValue];

    this.countryTarget.innerHTML = countries
      .map(c => `<option value="${c}">${c}</option>`)
      .join('');

    this.countryTarget.value = this.defaultCountryValue;
    this.initSelect2();
  }

  getFlagUrl(countryCode) {
    return `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
  }

  async updateRates() {
    try {
      const data = this.vatData || await fetch('/wp-json/mezcalito/v1/vat-rates').then(res => res.json());
      const rates = data.filter(r => r.country === this.countryTarget.value);

      this.rateTarget.innerHTML = rates
        .map(r => `<option value="${r.rate}">${r.rate}%</option>`)
        .join('');

      this.recalculate();
    } catch (error) {
      // Error silencieuse en production
    }
  }

  onRateChange() {
    this.recalculate();
  }

  recalculate() {
    const rate = parseFloat(this.rateTarget.value || 0);
    this.updateCoef(rate);

    if (this.htTarget.value) {
      this.calculateTTC();
    } else if (this.ttcTarget.value) {
      this.calculateHT();
    }
  }

  calculateTTC() {
    const rate = parseFloat(this.rateTarget.value || 0);
    const ht = parseFloat(this.htTarget.value);

    if (this.isValidNumber(ht)) {
      const tva = this.round(ht * (rate / 100));
      const ttc = this.round(ht + tva);
      this.tvaTarget.value = tva;
      this.ttcTarget.value = ttc;
    } else {
      // Vider uniquement TTC et TVA, pas le HT
      this.tvaTarget.value = '';
      this.ttcTarget.value = '';
    }
  }

  calculateHT() {
    const rate = parseFloat(this.rateTarget.value || 0);
    const ttc = parseFloat(this.ttcTarget.value);

    if (this.isValidNumber(ttc)) {
      const ht = this.round(ttc / (1 + rate / 100));
      const tva = this.round(ttc - ht);
      this.tvaTarget.value = tva;
      this.htTarget.value = ht;
    } else {
      // Vider uniquement HT et TVA, pas le TTC
      this.tvaTarget.value = '';
      this.htTarget.value = '';
    }
  }

  calculateFromTVA() {
    const rate = parseFloat(this.rateTarget.value || 0);
    const tva = parseFloat(this.tvaTarget.value);

    if (this.isValidNumber(tva) && rate > 0) {
      // À partir de la TVA, on calcule le HT et le TTC
      // Formule: tva = ht * (rate / 100)
      // Donc: ht = tva / (rate / 100)
      const ht = this.round(tva / (rate / 100));
      const ttc = this.round(ht + tva);
      this.htTarget.value = ht;
      this.ttcTarget.value = ttc;
    } else if (this.tvaTarget.value === '' || this.tvaTarget.value === null) {
      // Si le champ TVA est vidé, on vide les autres champs
      this.htTarget.value = '';
      this.ttcTarget.value = '';
    }
  }

  isValidNumber(value) {
    return !isNaN(value) && value !== null;
  }

  round(value) {
    return +value.toFixed(2);
  }

  clearResults() {
    this.tvaTarget.value = '';
    this.ttcTarget.value = '';
    this.htTarget.value = '';
  }

  updateCoef(rate) {
    const coefTtc = rate > 0 ? 1 + (rate / 100) : 0;
    const coefHt = rate > 0 ? 1 / coefTtc : 0;
    this.coefTtcTarget.textContent = coefTtc.toFixed(3);
    this.coefHtTarget.textContent = coefHt.toFixed(3);
  }

}
